<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-circle-plus-outline"
          @click="addPath"
          >新增</el-button
        >
      </div>
      <div class="search_box"></div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box" style="height:100%">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          v-loading="tableLoading"
        >
          <el-table-column label="序号" width="70" align="center" type="index">
          </el-table-column>
          <el-table-column
            prop="emDeviceName"
            label="环测设备名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="emDeviceNum"
            label="环测设备序列号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="emDeviceIpPort"
            label="IP端口号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="emDeviceBrand"
            label="环测设备品牌"
            align="center"
          >
            <template slot-scope="scope">
              {{
                $Common.getDataName(emDeviceBrandList, scope.row.emDeviceBrand)
              }}
            </template>
          </el-table-column>
          <el-table-column prop="emDeviceStatus" label="状态" align="center">
            <template slot-scope="rowData">
              <el-tag v-if="rowData.row.emDeviceStatus == 1" type="info"
                >禁用</el-tag
              >
              <el-tag v-if="rowData.row.emDeviceStatus == 0">启用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="addTime" label="添加时间" align="center">
            <template slot-scope="rowData">
              <span v-if="rowData.row.addTime">{{
                $Common.dateFormatDateTwo(rowData.row.addTime)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="editData(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="delData(scope.row.emDeviceId)"
                      :underline="false"
                      >删除</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="equipmentStatus(scope.row.emDeviceNum)"
                      :underline="false"
                      >设备状态</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="equipmentAlarm(scope.row)"
                      :underline="false"
                      >设备报警</el-link
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <add-or-edit
      :dialogType="dialogType"
      :showDialog="showDialog"
      :dialogInfo="infoData"
      @saveClick="saveClick"
      @close="close"
    >
    </add-or-edit>
    <alarm-loading
      :dialogInfo="alarmInfo"
      :showDialog="alarmDialog"
      @close="aClose"
    >
    </alarm-loading>
  </div>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import AddOrEdit from "./components/AddOrEdit.vue";
import alarmLoading from "./components/alarmLoading.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    AddOrEdit,
    alarmLoading
  },
  props: {},
  data() {
    //这里存放数据
    return {
      requestData: {
        schoolId: this.$store.state.schoolId
      },
      tableData: [],
      tableLoading: false,
      infoData: {
        emDeviceId: "", //设备id（编辑时传）
        schoolId: "", //学校id
        emDeviceName: "", //环测设备名称
        emDeviceNum: "", //环测设备序列号（不可以编辑）
        emDeviceIpPort: "", //设备外网服务器端口号 一个外网服务器端口对应一台设备 其它品牌设备填写设备ip端口（不可以编辑）
        emDeviceBrand: "", //环测设备品牌
        emDeviceStatus: 0, //状态 0启用 1禁用
        notes: "", //备注 设备本地ip加双端口、局域服务器ip端口、外网服务器ip端口（不可以编辑）
        addTime: "" //添加时间
      },
      dialogType: "add",
      showDialog: false,
      alarmInfo: {
        emDeviceNum: "",
        emDeviceBrand: "",
        schoolId: this.$store.state.schoolId
      },
      alarmDialog: false
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {
    emDeviceBrandList() {
      return this.$store.state.select.emDeviceBrandList;
    },
    emAlarmTypeList() {
      return this.$store.state.select.emAlarmTypeList;
    }
  },
  //方法集合
  methods: {
    searchData() {
      this.getTableData();
    },
    async getTableData() {
      this.tableLoading = true;
      let res = await this.$Http.getMonitoringDevice(this.requestData);
      this.tableLoading = false;
      if (res.code == 200) {
        this.tableData = res.data || [];
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.tableData = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    // 删除数据
    delData(id) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await this.$Http.delMonitoringDevice({ emDeviceId: id });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getTableData();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    addPath() {
      this.showDialog = true;
      this.dialogType = "add";
      delete this.infoData.emDeviceId;
      this.infoData.schoolId = this.$store.state.schoolId;
    },
    editData(info) {
      this.showDialog = true;
      this.dialogType = "edit";
      this.infoData = Object.assign({}, info);
      this.infoData.schoolId = this.$store.state.schoolId;
    },
    saveClick(info) {
      if (this.dialogType == "add") {
        info.addTime = Date.parse(new Date()) / 1000;
      }
      this.optionInfo(info);
    },
    async optionInfo(info) {
      let res = await this.$Http.operateMonitoringDevice(info, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: (this.dialogType = "add" ? "新增成功!" : "编辑成功")
        });
        this.getTableData();
        this.close();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    close() {
      this.showDialog = false;
      this.clearData();
    },
    clearData() {
      this.infoData = {
        emDeviceId: "", //设备id（编辑时传）
        schoolId: "", //学校id
        emDeviceName: "", //环测设备名称
        emDeviceNum: "", //环测设备序列号（不可以编辑）
        emDeviceIpPort: "", //设备外网服务器端口号 一个外网服务器端口对应一台设备 其它品牌设备填写设备ip端口（不可以编辑）
        emDeviceBrand: "", //环测设备品牌
        emDeviceStatus: 0, //状态 0启用 1禁用
        notes: "", //备注 设备本地ip加双端口、局域服务器ip端口、外网服务器ip端口（不可以编辑）
        addTime: "" //添加时间}
      };
    },
    equipmentStatus(deviceNum) {
      let routeUrl = this.$router.resolve({
        path: "/e_equipment_status?deviceNum=" + deviceNum
      });
      window.open(routeUrl.href, "_blank");
    },
    equipmentAlarm(info) {
      this.alarmInfo.emDeviceNum = info.emDeviceNum;
      this.alarmInfo.emDeviceBrand = info.emDeviceBrand;
      this.alarmDialog = true;
    },
    aClose() {
      this.alarmDialog = false;
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.getTableData();
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>
